import Create from '../../../base/errors/user/Create';

const create: Create = {
  GeneralError: 'Došlo k chybě při zpracování, zkuste prosím akci opakovat. Při přetrvávajících problémech kontaktujte Calypso group s kódem <{trackingId}>.',
  DuplicateUserName: 'Uživatelské jméno již existuje',
  UnableToSetNotificationChannel: 'Uživatel byl úspěšně vytvořen, avšak notifikace se nepodařilo nastavit. Zkuste to prosím později.'
};

export default create;
